import { differenceInCalendarDays } from 'date-fns';
import { TimelineScrollAnchor } from 'shared/types/timeline';
import { Timestamp } from 'shared/types/timestamp';

export type GetTimelineScrollLeftOptions = {
  anchor: TimelineScrollAnchor;
  referenceDate: Timestamp;
  today: Timestamp;
  rangeStartDate: Timestamp;
  dayWidth: number;
  viewportWidth: number;
};

// TimeframeStart puts the reference date at the viewport's left edge; Today puts the today line at its center.
export const getTimelineScrollLeft = ({
  anchor,
  referenceDate,
  today,
  rangeStartDate,
  dayWidth,
  viewportWidth,
}: GetTimelineScrollLeftOptions): number => {
  if (dayWidth <= 0) {
    return 0;
  }
  if (anchor === TimelineScrollAnchor.TimeframeStart) {
    return differenceInCalendarDays(referenceDate, rangeStartDate) * dayWidth;
  }
  const todayLeft = differenceInCalendarDays(today, rangeStartDate) * dayWidth;
  return Math.max(0, todayLeft - viewportWidth / 2);
};
